import { useState, useEffect } from 'react';
import ApiService from '../services/api';
import { Banner, Service, Work, ApiResponse } from '../types';

export const useBanners = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetched, setFetched] = useState(false);

  const fetchBanners = async () => {
    if (fetched) return;
    setLoading(true);
    try {
      const response = await ApiService.getBanners();
      setBanners((response as any).data);
      setFetched(true);
    } catch (err) {
      setError('Failed to fetch banners');
    } finally {
      setLoading(false);
    }
  };

  return { banners, loading, error, fetchBanners };
};

export const useServices = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetched, setFetched] = useState(false);

  const fetchServices = async () => {
    if (fetched) return;
    setLoading(true);
    try {
      const response = await ApiService.getServices();
      setServices((response as any).data);
      setFetched(true);
    } catch (err) {
      setError('Failed to fetch services');
    } finally {
      setLoading(false);
    }
  };

  return { services, loading, error, fetchServices };
};

export const useWorks = (params?: { category?: string; featured?: boolean }) => {
  const [works, setWorks] = useState<Work[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetched, setFetched] = useState(false);

  const fetchWorks = async () => {
    if (fetched) return;
    setLoading(true);
    try {
      const response = await ApiService.getWorks(params);
      setWorks((response as any).data);
      setFetched(true);
    } catch (err) {
      setError('Failed to fetch works');
    } finally {
      setLoading(false);
    }
  };

  return { works, loading, error, fetchWorks };
};

export const useFormSubmission = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const submitContact = async (data: any) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    
    try {
      await ApiService.submitContact(data);
      setSuccess(true);
    } catch (err) {
      setError('Failed to submit contact form');
    } finally {
      setLoading(false);
    }
  };

  const submitBooking = async (data: any) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    
    try {
      await ApiService.submitBooking(data);
      setSuccess(true);
    } catch (err) {
      setError('Failed to submit booking form');
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setError(null);
    setSuccess(false);
  };

  return { loading, error, success, submitContact, submitBooking, reset };
};